module.exports = __webpack_public_path__ + "static/anstruth_harp-108ed3c418857d1c97572279137c031a.jpg";